<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Colors</h6>
            </div>
          </header>
          <div class="vs-card--content text-center">
            <vs-progress :percent="100" color="primary">primary</vs-progress>
            <vs-progress :percent="90" color="warning">warning</vs-progress>
            <vs-progress :percent="75" color="danger">danger</vs-progress>
            <vs-progress :percent="60" color="success">success</vs-progress>
            <vs-progress :percent="45" color="dark">dark</vs-progress>
            <vs-progress :percent="30" color="rgb(164, 69, 15)"
              >RGB</vs-progress
            >
            <vs-progress :percent="15" color="#24c1a0">HEX</vs-progress>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Indeterminate</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-progress indeterminate color="primary">primary</vs-progress>
            <vs-progress indeterminate color="warning">warning</vs-progress>
            <vs-progress indeterminate color="danger">danger</vs-progress>
            <vs-progress indeterminate color="success">success</vs-progress>
            <vs-progress indeterminate color="dark">dark</vs-progress>
            <vs-progress indeterminate color="rgb(164, 69, 15)"
              >RGB</vs-progress
            >
            <vs-progress indeterminate color="#24c1a0">HEX</vs-progress>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Height</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-progress :height="2" :percent="100" color="primary"
              >primary</vs-progress
            >
            <vs-progress :height="4" :percent="80" color="warning"
              >warning</vs-progress
            >
            <vs-progress :height="8" :percent="60" color="danger"
              >danger</vs-progress
            >
            <vs-progress :height="12" :percent="40" color="success"
              >success</vs-progress
            >
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
    switch1: true,
    number1: 10,
  }),
};
</script>
